<template>
  <div class="chart">
    <div class="flex flex-wrap px-[100px] md:pt-5 pt-3 pb-3 md:pb-2 justify-between">

      <h1 class="font-family-card 	">Current Year</h1>
      <div ref="legendContainer" class="flex text-sm"></div>
    </div>
    <canvas ref="chartCanvas"  class="md:px-[70px] chart-height px-[50px] pb-9 "></canvas>
  </div>
</template>

<script setup>
import { onMounted, ref, watchEffect } from 'vue';
import Chart from 'chart.js/auto';
import { defineProps } from 'vue';

const props = defineProps({
  cardData: Object,
});

const chartCanvas = ref(null);
const legendContainer = ref(null);
let currentLegend = null;
onMounted(() => {
  watchEffect(() => {
    if (chartCanvas.value && props.cardData) {
      if (chartCanvas.value.chart) {
        chartCanvas.value.chart.destroy();
      }
      const ctx = chartCanvas.value.getContext('2d');

      if (ctx) {
        if (chartCanvas.value.chart) {
          chartCanvas.value.chart.destroy();
        }

        chartCanvas.value.chart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: [''],
            datasets: [
              {
                label: 'Collected',
                data: [props.cardData.currentYearCollectionCount],
                backgroundColor: '#85A9FB',
                borderColor: '#85A9FB',
                borderWidth: 1,
                borderRadius: 5,
              },
              {
                label: 'Disposed',
                data: [props.cardData.currentYearIncinerationCount],
                backgroundColor: '#2E2C72',
                borderColor: '#2E2C72',
                borderWidth: 1,
                borderRadius: 5,
              },
            ],
          },
          options: {
            animation: {
              animateRotate: true,
              animateScale: true,
            },
            responsive: true,
            
            top: 'end',
            plugins: {
              legend: {
                display: false,
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Weight (KGs)',
                  padding: {
                    top: 10,
                    bottom: 10
                  }
                }
              }
            },
          },
        });

        // Generate and set the custom legend HTML
        if (legendContainer.value) {
          legendContainer.value.innerHTML = generateLegend(chartCanvas.value.chart);
        }

        // Attach click event listener to legend items
        if (legendContainer.value) {
          legendContainer.value.addEventListener('click', handleLegendItemClick);
        }
      } else {
        console.error('Canvas context is not available.');
      }
    }
  });
});

// Function to generate custom legend HTML
function generateLegend(chart) {
  const legendItems = chart.legend.legendItems.map((item, index) => {
    const colorBox = `<span style="background-color: ${item.fillStyle}; border-radius:3px; width: 15px; height: 15px; display: inline-block; margin-right: 5px;"></span>`;
    return `<li data-index="${index}" class="pr-5" style="list-style-type: none; align-items:center; display:flex; cursor: pointer;">${colorBox}${item.text}</li>`;
  });

  return `<ul class="flex " style="padding: 0;">${legendItems.join('')}</ul>`;
}

// Handle legend item click
function handleLegendItemClick(event) {
  const clickedIndex = event.target.getAttribute('data-index');
  if (clickedIndex !== null) {
    if (chartCanvas.value.chart) {
      const meta = chartCanvas.value.chart.getDatasetMeta(clickedIndex);
      if (meta) {
        // Toggle visibility of the clicked dataset
        meta.hidden = !meta.hidden;

        // Update legend
        updateLegend();
      } else {
        console.error('Chart meta information not available.');
      }
    } else {
      console.error('Chart instance not available.');
    }
  }
}


function updateLegend() {
  // Use the update method of the chart instance
  chartCanvas.value.chart.update();
}

</script>

<style scoped>
/* Add any scoped styles if needed */
</style>
